import { render, staticRenderFns } from "./exists_mini_program.vue?vue&type=template&id=dfe22ed2&"
import script from "./exists_mini_program.vue?vue&type=script&lang=js&"
export * from "./exists_mini_program.vue?vue&type=script&lang=js&"
import style0 from "./exists_mini_program.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports